<script>
import {mapActions, mapGetters, mapMutations, mapState} from "vuex";
import _ from "lodash";
import store from "../../../../../stores/application/index.js.erb";

export default {
  name: "FormationHostelOrder",

  data: () => ({
    status_place: '',
    snackbar: false,
    error_states: [],
    show_error: false,
    type_order: '',
    list_order_types: ['Заселение', 'Выселение', 'Переселение'],
    headers_table_state: [
      {text: 'ФИО', value: 'full_name', sortable: false},
      {text: 'СТАТУС РАЗМЕЩЕНИЯ', value: 'status_accommodation', align: "center", sortable: false, filterable: false},
      {text: 'МЕСТО РАЗМЕЩЕНИЯ', value: 'place_settlement', align: "center", sortable: false, filterable: false},
      {text: 'ДАТА РАЗМЕЩЕНИЯ', value: 'created_at', align: "center", sortable: false, filterable: false}
    ],
    page: 1,
    pageCount: 0,
    search_table: '',
    check_forming: false,
    selected_distributions_records: []
  }),
  mounted() {
  },
  watch: {
    selected_distributions_records: function (selected_distributions_records) {
      this.check_forming = selected_distributions_records.length > 0
    }
    // show_error: function (show_error) {
    //     if (show_error === false) this.error_states = []
    // }
  },
  computed: {
    ...mapState({
      distribution_persons_records: state => state.hostelOrders.distribution_persons_records,
      status_distr_pers_records: state => state.hostelOrders.status_distr_pers_records,
    }),
    ...mapGetters({}),
  },
  methods: {
    ...mapMutations({
      setTreeStatements: 'interactionStatement/setTreeStatements',
    }),
    ...mapActions({
      CreateOrder: 'hostelOrders/CreateOrder',
      GetListDistributionHostelStatements: 'interactionStatement/GetListDistributionHostelStatements',
    }),
    async createOrder() {
      await this.CreateOrder(this.selected_distributions_records)
      this.snackbar = true
      this.setStepListOrders()
    },
    setStepListOrders() {
      this.$emit('setStepListOrders')
    },
  },
}
</script>

<template>
  <v-card height="600px" elevation="0">
    <v-card-title>
      <v-btn icon @click="setStepListOrders">
        <v-icon size="20px">
          fa-chevron-left
        </v-icon>
      </v-btn>
      <div class="text--secondary">Формирование приказа</div>
    </v-card-title>
    <v-card-text style="height: calc(100% - 126px)">
      <v-data-table
          v-model="selected_distributions_records"
          show-select
          :headers="headers_table_state"
          :items="distribution_persons_records"
          :items-per-page="7"
          :page.sync="page"
          :loading="status_distr_pers_records"
          loading-text="Загрузка заявлений... пожалуйста подождите"
          @page-count="pageCount = $event"
          no-data-text="По предложенным критериям данные отсутствуют"
          hide-default-footer
          mobile-breakpoint="0"
      >
        <template v-slot:top>
          <v-app-bar
              elevation="0"
          >
            <v-row no-gutters>
              <v-col cols="12" md="6">
                <v-text-field
                    v-model="search_table"
                    label="Поиск"
                    dense
                    outlined
                    hide-details
                    clearable
                    @click:clear="search_table = ''"
                >
                  <template v-slot:prepend>
                    <v-icon size="20px">
                      fa-search
                    </v-icon>
                  </template>
                </v-text-field>
              </v-col>
              <v-col class="d-flex justify-end" cols="12" md="6">
                <v-slide-x-transition>
                  <v-btn
                      @click="createOrder(selected_distributions_records)"
                      v-if="check_forming"
                      rounded
                      dark
                      color="teal"
                  >
                    Сформировать приказы
                  </v-btn>
                </v-slide-x-transition>
              </v-col>
            </v-row>
          </v-app-bar>
        </template>
        <template v-slot:item.status_accommodation="{ item }">
          <v-chip
              small
              rounded
              elevation="0"
              outlined
          >
            {{ item.status_accommodation }}
          </v-chip>
        </template>
      </v-data-table>
    </v-card-text>
    <v-card-actions>
      <v-pagination
          class="mx-auto"
          v-model="page"
          :length="pageCount"
          total-visible="8"
          color="teal"
          circle
      ></v-pagination>
    </v-card-actions>
  </v-card>
</template>

<style scoped>

</style>